import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import flex from '../css/module/flex.css';

class MoreInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  render() {
    const { children, label } = this.props;

    const iconStyle = { marginLeft: '5px', fontSize: '1.1em' };
    return (
      <div>
        <div
          onClick={() => this.setState({ open: !this.state.open })}
          className={`${flex.alignItemsCenter} user-clickable margin-top-10`}
        >
          {label}
          {this.state.open ? (
            <FontAwesomeIcon icon="caret-down" style={iconStyle} />
          ) : (
            <FontAwesomeIcon icon="caret-right" style={iconStyle} />
          )}
        </div>
        {!this.state.open ? null : (
          <div className="margin-top-10">{children}</div>
        )}
      </div>
    );
  }
}

export default MoreInfo;
